<template>
  <div>
    <Row style="padding: 20px">
      <Col span="12">
        <Input v-model="params.name" placeholder="请输入名称" class="search" />
        <Button
          type="primary"
          icon="md-search"
          @click="getList"
          v-access="'merchant.relation.query'"
          >搜索</Button
        >
        <Button @click="resetList" v-access="'merchant.relation.reset'"
          >重置</Button
        >
      </Col>
      <Col span="12">
        <Button
          type="primary"
          icon="md-add"
          class="add"
          @click="create"
          v-access="'merchant.relation.add'"
          >添加</Button
        >
        <Button
          type="primary"
          icon="md-cloud-download"
          class="add"
          @click="importHandler"
          >导入</Button
        >
        <Button
          type="primary"
          icon="md-cloud-upload"
          class="add"
          @click="exportHandler"
          >导出</Button
        >
      </Col>
      <Col span="24">
        <Table
          class="table"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="shopInfoQueryList.data || []"
        >
          <template slot-scope="{ index }" slot="no">
            <span>{{
              params.pageSize * (params.pageNum - 1) + index + 1
            }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <a
              style="margin-right: 5px"
              @click="changeServiceModalVisible = true"
              v-access="'merchant.relation.query'"
              >详情</a
            >
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="shopInfoQueryList.total"
          show-sizer
          show-total
          prev-text="Previous"
          next-text="Next"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
    <!-- 单个分类 -->
    <Modal
      v-model="changeServiceModalVisible"
      title="修改挂靠服务商"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="modalFormItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="平台" prop="name">
          <Input v-model="modalFormItem.name" placeholder="请输入平台"></Input>
        </FormItem>
        <FormItem label="门店ID" prop="pName">
          <Select v-model="modalFormItem.stype" style="width: 60%"> </Select>
        </FormItem>
        <FormItem label="服务商编号" prop="pName">
          <Select v-model="modalFormItem.stype" style="width: 60%"> </Select>
        </FormItem>
      </Form>
      <form action=""></form>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "no",
    width: 80,
  },
  {
    title: "平台",
    key: "stype",
  },
  {
    title: "门店ID",
    key: "groupCode",
  },
  {
    title: "门店名称",
    key: "businessInfo",
  },
  {
    title: "门店渠道",
    key: "channelCode",
  },
  {
    title: "服务商编号",
    key: "dealerLevel",
  },
  {
    title: "服务商分类",
    key: "name",
  },
  {
    title: "服务商名称",
    key: "name",
  },
  {
    title: "服务商渠道",
    key: "name",
  },
  {
    title: "服务商角色",
    key: "name",
  },
  {
    title: "创建时间",
    key: "name",
  },
  {
    title: "更新时间",
    key: "name",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  data() {
    return {
      loading: false,
      columns,

      params: {
        pageSize: 10,
        pageNum: 1,
        name: "",
      },

      changeServiceModalVisible: false,
      formModalLoading: true,
      modalFormItem: {
        name: "",
        pName: "",
        pCode: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      shopInfoQueryList: "merchant/getShopInfoQueryList",
    }),
  },
  created() {
    this.getList();

    // setTimeout(() => {
    //   console.log(this.shopInfoQueryList)
    // }, 2000)
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("merchant/shopInfoQueryList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.pageNum = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.pageNum == 1) {
        this.getList();
      } else {
        this.params.pageNum = 1;
      }
    },
    // 重置
    resetList() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.name = "";
      this.getList();
    },
    // 添加
    create() {
      this.$router.push({
        path: "relationCreate",
        // query:
      });
    },
    // 导入
    importHandler() {},
    // 导出
    exportHandler() {},
    // 详情
    detail(row, index) {},
  },
};
</script>
<style scoped>
.search {
  margin-right: 15px;
  width: 300px;
}
.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/merchant/relation/list.vue